<template>
  <section class="tw-mx-auto tw-max-w-7xl tw-px-4 sm:tw-px-6 lg:tw-px-8">
    <sign-up />
  </section>
</template>
<script>
import { mapGetters } from 'vuex';
import SignUp from '@/components/SignUp.vue';
export default {
  name: 'FreeSignupPage',
  components: {
    SignUp,
  },
  layout({ $isFlagOn }) {
    return $isFlagOn('signup-flow-hide-header-footer') ? 'minimal' : 'default';
  },
  data() {
    return {
      title: 'Sign up',
      description: 'Sign up to create a free Teach Starter account',
    };
  },
  head() {
    return {
      title: this.title,
      meta: [
        { hid: 'title', name: 'title', content: this.title },
        { hid: 'description', name: 'description', content: this.description },
      ],
      link: this.$hrefLangsPage(this.$route),
    };
  },
  computed: {
    ...mapGetters(['loggedInUser']),
  },
  created() {
    if (this.loggedInUser) {
      this.$router.push('/hub/');
    }
  },
};
</script>
